import { Box, Center, IconButton } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { MdPersonOutline } from 'react-icons/md';

import { CustomerContext } from '@repo/contexts';
import Link from '@repo/ui-components/tailwind/Link';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

export default function NavAccountButton() {
  const customerContext = useContext(CustomerContext);
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Box pos="relative" as={Link} link="/account">
      <IconButton
        icon={<MdPersonOutline size={24} />}
        variant="nav"
        aria-label={tt(s => s.navAccountButtonComponent.profileAriaLabel)}
      />
      {customerContext?.customer?.isAuthenticated ? (
        <Center
          background="brand.sunny"
          borderRadius="full"
          p="1"
          pos="absolute"
          top="3"
          right="6px"
          w="2"
          h="2"
          cursor="pointer"
        />
      ) : null}
    </Box>
  );
}
